export default "__VITE_ASSET__BKmCLGnR__"